import { Outlet } from "react-router-dom";
import { TopNav, BottomTabs } from "@/components/Nav";
import { ConciergeWidget } from "@/components/ConciergeWidget";
import { Footer } from "@/components/Footer";
import { useIsMobile } from "@/hooks/useMediaQuery";
import { colors } from "@/theme";

export function Layout() {
  const isMobile = useIsMobile();
  return (
    <div style={{ minHeight: "100vh", background: colors.surface, display: "flex", flexDirection: "column" }}>
      <TopNav />
      <main style={{ flex: 1, paddingBottom: isMobile ? 80 : 0 }}>
        <Outlet />
      </main>
      {isMobile && <BottomTabs />}
      <ConciergeWidget />
      <Footer isMobile={isMobile} />
    </div>
  );
}
